export default __webpack_public_path__ + "static/Mulher-costas-3427078ae61be18a7e08acacfe68d2e1.jpg";